// Quick preset ranges shown as buttons above the transaction list, plus the
// pure date-math backing them - kept separate from TxnList so it's independently testable.

export const PRESET_RANGES = [
  { label: '3D', hours: 72 },
  { label: '7D', hours: 24 * 7 },
  { label: '15D', hours: 24 * 15 },
  { label: '1M', hours: 24 * 30 },
]

export const DEFAULT_PRESET = PRESET_RANGES[0]

// [from, to] unix-seconds window for a preset, ending "now".
export function computePresetRange(preset, nowSeconds = Math.floor(Date.now() / 1000)) {
  const to = nowSeconds
  const from = to - preset.hours * 3600
  return { from, to }
}

// Calendar-day boundaries in the browser's local time, for the custom date picker
// (which picks whole days, not times). `to` is exclusive, so it's the start of the
// day *after* the picked "to" day - that way the picked day's own transactions are included.
export function startOfDayUnix(date) {
  const d = new Date(date)
  d.setHours(0, 0, 0, 0)
  return Math.floor(d.getTime() / 1000)
}

export function endOfDayExclusiveUnix(date) {
  return startOfDayUnix(date) + 24 * 3600
}

export function isValidRange(from, to) {
  return Number.isFinite(from) && Number.isFinite(to) && from < to
}
